import useDeals from './useDeals';
export type { Deal } from './useDeals';

export default function useDeal(orgId?: string) {
  const { deals, loading, error } = useDeals({ enabled: Boolean(orgId), orgId });
  return { deal: deals[0] || null, loading, error };
}
